function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t\n\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke-width:1.68;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "2.2,14 2.2,2.9 22.5,2.9 22.5,19 10.9,19 7.7,22.2 "
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 6.7,
  y1: 6.9,
  x2: 17.8,
  y2: 6.9
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 6.7,
  y1: 11,
  x2: 17.8,
  y2: 11
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 6.7,
  y1: 15.2,
  x2: 14.8,
  y2: 15.2
});

var SvgSafeSafeDolneMenuInfoWhite = function SvgSafeSafeDolneMenuInfoWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Info-white",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSafeSafeDolneMenuInfoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SafeSafe-dolne-menu-Info-white.32b14e82.svg";
export { ForwardRef as ReactComponent };